import React, { useReducer } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reducer, { defaultState, updateFieldCreator } from './reducer';
import {
  createMaTrainingCreator,
  setMaTrainingsCreateErrorsCreator,
} from '../../../../../store/actionsCreators';
import AddTraining from '../../../../../shared/Cpd/Trainings/Add/AddTraining';

const AddMaTraining = ({ errors, createTraining, removeError }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <AddTraining
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      errors={errors}
      createTraining={createTraining}
      removeError={removeError}
    />
  );
};

AddMaTraining.propTypes = {
  errors: PropTypes.object,
  createTraining: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
};

AddMaTraining.defaultProps = {
  errors: {},
};

const mapStateToProps = ({ ma }) => ({
  errors: ma.trainings.createErrors,
});

const mapDispatchToProps = (dispatch) => ({
  createTraining: (payload, history) => dispatch(createMaTrainingCreator(payload, history)),
  removeError: (payload) => dispatch(setMaTrainingsCreateErrorsCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddMaTraining);
